<template>
  <statistik-base :value="value" :stats="stats"></statistik-base>
</template>

<script>
import StatistikBase from '@/components/shared/StatistikBase';
export default {
  name: 'Statistik',
  components: { StatistikBase },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    gelombang: {
      type: [Number, String],
      default: 1,
    },
    meta: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    stats() {
      let statAngkatan3 = [
        {
          icon: 'mdi-file-check',
          color: 'indigo',
          label: 'Laporan Pembukaan IHT',
          key: '6',
          grid: { cols: 12, md: this.meta.is_vokasi ? 4 : 6, sm: 12 },
        },
        {
          icon: 'mdi-file-check',
          color: 'pink',
          label: 'Laporan Akhir IHT',
          key: '7',
          grid: { cols: 12, md: this.meta.is_vokasi ? 4 : 6, sm: 12 },
        },
      ];

      if (this.meta.is_vokasi) {
        statAngkatan3 = [
          ...statAngkatan3,
          ...[
            {
              icon: 'mdi-file-check',
              color: 'green',
              label: 'Laporan Evaluasi IHT',
              key: '8',
              grid: { cols: 12, md: 4, sm: 12 },
            },
          ],
        ];
      }

      const laporans = {
        1: [
          {
            icon: 'mdi-file-check',
            color: 'indigo',
            label: 'Laporan IHT 1',
            key: '1',
            grid: { cols: 12, md: 4, sm: 12 },
          },
          {
            icon: 'mdi-file-check',
            color: 'pink',
            label: 'Laporan IHT 2',
            key: '2',
            grid: { cols: 12, md: 4, sm: 12 },
          },
          {
            icon: 'mdi-file-check',
            color: 'orange',
            label: 'Laporan IHT 3',
            key: '3',
            grid: { cols: 12, md: 4, sm: 12 },
          },
        ],
        2: [
          {
            icon: 'mdi-file-check',
            color: 'indigo',
            label: 'Laporan Pembukaan IHT',
            key: '4',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            icon: 'mdi-file-check',
            color: 'pink',
            label: 'Laporan Akhir IHT',
            key: '5',
            grid: { cols: 12, md: 6, sm: 12 },
          },
        ],
        3: statAngkatan3,
      };

      return laporans[this.gelombang] || [];
    },
  },
};
</script>

<style scoped></style>
